import React from "react";
import '../../App.css';

export default function Reservations() {
    return (
        <>
            <h1 className="reservations">Réservations</h1>
            <div>Salut je m'appelle réservations</div>
        </>
    ) 
}